export default "__VITE_ASSET__DnMux927__"